import { DROPS_FILTER_SECTION_MAP, DROPS_STALE_TIME_MS, DROPS_INITIAL_PAGE, DROPS_PER_PAGE, DROPS_TAB_SECTION_MAP, } from 'root/src/client/v2/_pages/drops/fixtures/drops.constants';
import { DropSerializer } from 'root/src/shared/drops/drops.constants';
import { useDropEventListFiltersContext, } from 'root/src/client/v2/_pages/drops/contexts/dropEventListFilters.context';
import { trpc } from 'root/src/client/v2/trpc/trpc';
export const useDropsList = () => {
    const { tab, filter } = useDropEventListFiltersContext();
    const dropsQuery = trpc.drops.getManyPaginated.useInfiniteQuery({
        section: DROPS_TAB_SECTION_MAP[tab],
        limit: DROPS_PER_PAGE,
        serializer: DropSerializer.LIST_VIEW,
        dataFilter: DROPS_FILTER_SECTION_MAP[filter],
    }, {
        initialCursor: DROPS_INITIAL_PAGE,
        getNextPageParam: (lastPage) => {
            const isFinished = lastPage.allPage <= lastPage.currentPage;
            if (!isFinished) {
                return lastPage.currentPage + 1;
            }
            return null;
        },
        staleTime: DROPS_STALE_TIME_MS,
    });
    return {
        dropsQuery,
    };
};
